import { create } from 'zustand';
import type { AccountStats } from '@/api/spec.ts';

interface AccountStatsState {
  stats: AccountStats | undefined;
  setSnapshot: (stats: AccountStats) => void;
  patch: (stats: AccountStats) => void;
  reset: () => void;
}

export const useAccountStatsStore = create<AccountStatsState>()((set) => ({
  stats: undefined,
  setSnapshot: (stats) => set({ stats }),
  patch: (update) =>
    set((state) => {
      if (!state.stats) return { stats: update };
      return { stats: { ...state.stats, ...update } };
    }),
  reset: () => set({ stats: undefined }),
}));
